import { Helmet } from "react-helmet";
import isCurrentlyOnBrandTVDomain from "@/utils/is-currently-on-btv-domain";
import isCurrentlyOnWebinarPlusDomain from "@/utils/is-currently-on-webinarplus-domain";

export default function Favicons({ customFavicon }: { customFavicon?: string } = {}): JSX.Element {
	const isBrandTV = isCurrentlyOnBrandTVDomain();
	const isWebinarPlus = isCurrentlyOnWebinarPlusDomain();

	// Should already be set with image resizer in html from events-app-server-3
	if (customFavicon) {
		return <></>;
	}

	return (
		<Helmet>
			{/* Light favicon on dark mode, dark favicon on light mode. Fragments </> can't be used here. */}
			{isWebinarPlus && <link rel="icon" href={`${process.env.PUBLIC_URL}/webinar-plus-light-favicon.png`} media="(prefers-color-scheme: dark)" />}
			{isWebinarPlus && <link rel="icon" href={`${process.env.PUBLIC_URL}/webinar-plus-dark-favicon.png`} media="(prefers-color-scheme: light)" />}
			{isBrandTV && <link rel="icon" href={`${process.env.PUBLIC_URL}/brandtv-light-favicon.png`} media="(prefers-color-scheme: dark)" />}
			{isBrandTV && <link rel="icon" href={`${process.env.PUBLIC_URL}/brandtv-dark-favicon.png`} media="(prefers-color-scheme: light)" />}
			{!isWebinarPlus && !isBrandTV && <link rel="icon" href={`${process.env.PUBLIC_URL}/brandlive-favicon.png`} />}
		</Helmet>
	);
}